import { type AxiosResponse } from 'axios';

import { request } from '../../../../services/requestService';

import { type IRiskResponse } from '../../types/response';

const ENDPOINTS = {
  risk: 'risk',
};

export function getLpcoRisks(id: string): Promise<AxiosResponse<IRiskResponse[]>> {
  return request({
    url: `${ENDPOINTS.risk}/${id}`,
  });
}
